const UID = length => {
  const ALPHABET = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const ID_LENGTH = length || 8
  let UUID = ''
  for (let i = 0; i < ID_LENGTH; i += 1) {
    UUID += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length))
  }
  return UUID
}

const GLOBAL = {
  qlik: null,
  resize: null,
}

export default { UID, GLOBAL }
